"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = refreshCartTotal;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var pipe = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (v) {
    return fns.reduce(function (r, fn) {
      return fn(r);
    }, v);
  };
};

var calcTotal = function calcTotal(price, quantity, numberOfRepeats, fixedPrice) {
  return (price || 0) * (fixedPrice ? 1 : quantity || 0) * (numberOfRepeats || 1);
};

function refreshCartTotal(cart) {
  var nextCart = pipe(function (xcart) {
    return (0, _extends2.default)({}, xcart, {
      indirectSubjects: (xcart.indirectSubjects || []).map(function (s) {
        return (0, _extends2.default)({}, s, {
          subjectTotal: calcTotal(s.price, s.quantity, s.numberOfRepeats, s.fixedPrice)
        });
      }),
      payment: (0, _extends2.default)({}, xcart.payment, {
        subjectTotal: function (pm) {
          return calcTotal(pm.price || 0, pm.quantity || 1, pm.numberOfRepeats, pm.fixedPrice);
        }(xcart.payment || {})
      }),
      shipping: (0, _extends2.default)({}, xcart.shipping, {
        subjectTotal: function (sp) {
          return calcTotal(sp.price || 0, sp.quantity || 1, sp.numberOfRepeats, sp.fixedPrice);
        }(xcart.shipping || {})
      }),
      subjects: (xcart.subjects || []).map(function (s) {
        return (0, _extends2.default)({}, s, s.indirectSubjects ? {
          indirectSubjects: s.indirectSubjects.map(function (is) {
            return (0, _extends2.default)({}, is, {
              subjectTotal: calcTotal(is.price, is.deleted ? 0 : is.quantity, is.numberOfRepeats, is.fixedPrice)
            });
          })
        } : {}, {
          subjectTotal: calcTotal(s.price, s.quantity, s.numberOfRepeats, s.fixedPrice)
        });
      })
    });
  }, function (xcart) {
    return (0, _extends2.default)({}, xcart, {
      total: xcart.indirectSubjects.reduce(function (t, s) {
        return t + s.subjectTotal;
      }, 0) + xcart.subjects.reduce(function (t, s) {
        return t + s.subjectTotal + (s.indirectSubjects || []).reduce(function (isr, is) {
          return isr + is.subjectTotal;
        }, 0);
      }, 0) + xcart.payment.subjectTotal + xcart.shipping.subjectTotal
    });
  })(cart || {});
  return nextCart;
}